// import * as React from 'react';
// import * as $ from 'jquery';

// import WidgetPopupHeader from '../popup/WidgetPopupHeader.react';

class ConfirmPopup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false
        };

        this.show = this.show.bind(this);
        this.confirm = this.confirm.bind(this);
    }

    show() {
        this.setState({
            visible : true
        });
    }

    confirm() {
        var self = this;

        this.setState({
            visible : false
        }, () => {
            self.props.onConfirm();
        })
    }

    render() {
        var self = this;

        var type        = this.props.type || 'hidden',
            buttonClass = this.props.buttonClass || '',
            disabled    = this.props.disabled || false

        return ([
            ( type === 'button' &&
                <button
                    className={'btn-green '+buttonClass+' '+(disabled ? 'btn-green__disabled' : '')}
                    onClick={() => { this.setState({ visible : true }); }}
                    style={{'cursor':'pointer'}}
                    disabled={disabled}>

                    {this.props.buttonLabel || 'Save'}
                </button>
            ),

            ( this.state.visible &&
                <div className='smokescreen smokescreen__transparent'>
                    <div
                        className='confirm-popup'
                        style={{'width' : 300}}>

                        <div
                            className='confirm-popup__header'>

                            {this.props.title || 'Are you sure?'}
                        </div>

                        <button
                            className={'btn-green'}
                            onClick={this.confirm}>

                            {this.props.confirmLabel || 'Confirm'}
                        </button>

                        <button
                            className={'btn-green btn-green__disabled'}
                            style={{'float':'right'}}
                            onClick={() => {
                                this.setState({ visible : false }, () => {
                                    if (self.props.onCancel)
                                        self.props.onCancel();
                                })
                            }} >

                            {this.props.cancelLabel || 'Cancel'}
                        </button>
                    </div>
                </div>
            )
        ]);

        return null;
    }
}

export default ConfirmPopup;


// WEBPACK FOOTER //
// ./ui_src/app/components/common/ConfirmPopup.react.jsx